import custom from './custom';
import promoteJobs from './promoteJobs';
import promoteContentShares from './promoteContentShares';
// import scheduleJobs from './scheduleJobs';
// import scheduleContentShares from './scheduleContentShares';
import invite from './invite';
import leaderboardIndividual from './leaderboardIndividual';
import leaderboardOverall from './leaderboardOverall';
import collectiveGoal from './collectiveGoal';
import gamificationUpdateIndividual from './gamificationUpdateIndividual';
import promoteJob from './promoteJob';
import promoteContent from './promoteContent';

import picnicCustom from './picnic/custom';
import picnicInvite from './picnic/invite';
import picnicLeaderboardIndividual from './picnic/leaderboardIndividual';
import picnicLeaderboardOverall from './picnic/leaderboardOverall';
import picnicCollectiveGoal from './picnic/collectiveGoal';
import picnicGamificationUpdateIndividual from './picnic/gamificationUpdateIndividual';
import picnicPromoteJob from './picnic/promoteJob';
import picnicPromoteJobs from './picnic/promoteJobs';
import picnicPromoteContent from './picnic/promoteContent';
import picnicPromoteContentShares from './picnic/promoteContentShares';
// import picnicScheduleJobs from './picnic/scheduleJobs';
// import picnicScheduleContentShares from './picnic/scheduleContentShares';

export default client => {
  if (client === 'picnic') {
    return [
      picnicCustom,
      picnicInvite,
      picnicLeaderboardIndividual,
      picnicLeaderboardOverall,
      picnicCollectiveGoal,
      picnicGamificationUpdateIndividual,
      picnicPromoteJob,
      picnicPromoteJobs,
      picnicPromoteContent,
      picnicPromoteContentShares,
      // picnicScheduleJobs,
      // picnicScheduleContentShares
    ];
  }
  return [
    custom,
    invite,
    leaderboardIndividual,
    leaderboardOverall,
    collectiveGoal,
    gamificationUpdateIndividual,
    promoteJob,
    promoteJobs,
    promoteContent,
    promoteContentShares,
    // scheduleJobs,
    // scheduleContentShares
  ];
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/index.js